export function vaildateMaxDigits(amount = '') {
  const amountToString = typeof amount === 'string' ? amount : amount.toString();
  const decimalIndex = amountToString.indexOf('.');
  const roundedAmount = decimalIndex > 0 ? amountToString.slice(0, decimalIndex) : amountToString;
  return roundedAmount.length <= 11;
}
